<template>
  <div>
    <v-card class="white black--text">
      <cpnChartSelect :power_plants="power_plants"></cpnChartSelect>
    </v-card>
    <v-container fill-height fluid grid-list-xl>
      <v-layout wrap>
        <cpnCustomerMetrics v-if="!loading"></cpnCustomerMetrics>
        <cpnChartBilling v-if="!loading"></cpnChartBilling>
        <!-- <cpnPartnerSelect v-if="!this.$apollo.loading"></cpnPartnerSelect>
        <cpnBalance v-if="!this.$apollo.loading"></cpnBalance> -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Billing from "../components/charts/Billing.vue";
import CustomerMetrics from "../components/dashboard/CustomerMetrics.vue";
import PowerPlantSelect from "../components/dashboard/PowerPlantSelect.vue";
// import PartnerSelect from '../components/dashboard/balance/PartnerSelect'
// import Balance from '../components/dashboard/balance/Balance'
// import { GET_POWERPLANTCOMBO } from '../graphql/powerplants'
import firestore from "../firebase/firestore";

export default {
  data() {
    return {
      power_plants: [],
      power_plant: "",
      loading: false,
    };
  },
  components: {
    cpnChartBilling: Billing,
    cpnCustomerMetrics: CustomerMetrics,
    cpnChartSelect: PowerPlantSelect,
    // cpnPartnerSelect: PartnerSelect,
    // cpnBalance: Balance
  },
  created() {
    this.loading = true;
    firestore
      .collection("power_plants")
      .get()
      .then((power_plants) => {
        power_plants.docs.map((pp, index) => {
          const power_plant = {
            id: pp.id,
            ...pp.data(),
          };
          this.power_plants.push(power_plant);
          if (power_plants.size - 1 < index) {
            this.loading = false;
          }
        });
      });
  },
  // apollo: {
  //   powerplants: {
  //       query: GET_POWERPLANTCOMBO,
  //       // Optional result hook
  //       result ({ data, loading }) {
  //           this.power_plants = data.powerplants
  //           this.loading = loading
  //       },
  //       // Error handling
  //       error (error) {
  //           console.error('We\'ve got an error!', error)
  //       },
  //   }
  // }
};
</script>
